import { isEmpty, isNil } from 'lodash';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { enqueueClarityAction } from '~frontend-common/helper/core/clarity';

export interface ClarityProps {
  // Clarity project id
  projectId?: string;

  // Identifier accessor
  // If provided, will be used to set customId on every page change
  identifier?: () => string;
}

function Component({ projectId, identifier, location }: ClarityProps & RouteComponentProps<any>) {
  useEffect(() => {
    if (isNil(projectId)) {
      return;
    }

    const customId = identifier?.();
    if (isEmpty(customId)) {
      return;
    }

    enqueueClarityAction((clarity) => clarity('identify', customId, null, null, customId));
  }, [location.pathname]);

  if (isEmpty(projectId)) {
    // Only setup if projectId is defined
    return null;
  }

  return (
    <Helmet>
      <script type="text/javascript">
        {`
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "${projectId}");
        `}
      </script>
    </Helmet>
  );
}

export const Clarity = withRouter(Component);
